import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import { withTranslation } from "react-i18next";
import { APP_VERSION, is_dev_env } from "../Util/constant";
import { useSideBar } from "./context/SideBarContext";
import HelpButton from "./shared/HelpButton";
import { ProfileProvider } from "./context/ProfileContext";
import { WalletProvider } from "./context/WalletContext";
import { RankProvider } from "./context/RankContext";
import { useHistory } from "react-router-dom";

const App = () => {
  const history = useHistory();
  const currentYear = new Date().getFullYear();
  console.log("APP VERSION", APP_VERSION);

  const restrictedPaths = ["login", "registration", "forgotpassword"];
  const currentPath = window.location.pathname.toLowerCase();
  // Check if the current path contains any of the restricted words
  const shouldHide = restrictedPaths.some((path) => currentPath.includes(path));
  let renderSidebarAndNavbar = !shouldHide;

  // State for window width and sidebar icon-only state
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isSidebarIconOnly, setIsSidebarIconOnly] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("user_access_token");
    if (!token && is_dev_env === false) {
      if (shouldHide) {
        // If any restricted path than do not redirect to login
        return;
      }
      history.push({
        pathname: "/login",
      });
    }

    // Handle window resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { isSideBarOpen, toggleSideBar } = useSideBar();

  // Set a tablet breakpoint size (e.g., 768px)
  const tabletSize = 768;

  // Handle sidebar toggle to apply "sidebar-icon-only" class and state update
  const handleSidebarToggle = () => {
    document.body.classList.toggle("sidebar-icon-only");
    setIsSidebarIconOnly((prev) => !prev); // Toggle the state when sidebar icon-only is applied
    toggleSideBar(); // Ensure the sidebar state is toggled
  };

  // Dynamically adjust paddingLeft based on window width and sidebar state
  const footerStyle = isSidebarIconOnly
    ? { paddingLeft: "56px" }  // Apply 40px padding when sidebar is icon-only
    : windowWidth <= tabletSize
      ? { paddingLeft: "20px" }  // Apply 20px padding for smaller screens
      : { paddingLeft: "152px" }; // Default padding for larger screens and full sidebar

  return (
    <>

      {!renderSidebarAndNavbar ? (
        // Render only the AppRoutes without sidebar and navbar for restricted paths
        <AppRoutes />
      ) : (
        <ProfileProvider>
          <WalletProvider>
            <RankProvider>
              {/* // Default layout with sidebar and navbar */}
              <div className="container-scroller">
                {renderSidebarAndNavbar && <Sidebar />}
                <div className="container-fluid page-body-wrapper">
                  {renderSidebarAndNavbar && <Navbar onSidebarToggle={handleSidebarToggle} />}
                  <div className="main-panel">
                    <div
                      className={`content-wrapper ${isSideBarOpen
                        ? "content-wrapper-margin"
                        : "content-wrapper-margin2"
                        }`}
                    >
                      <AppRoutes />
                    </div>
                    <footer style={{
                      backgroundColor: "transparent",
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "left",
                      paddingBottom: "16px",
                      paddingTop: "0px",
                      ...footerStyle // Apply dynamic padding style
                    }}>
                      <span className="mb-0" style={{ fontSize: '14px' }}>
                        © {currentYear}, made with ❤️ by ARBITFX
                      </span>
                    </footer>
                  </div>
                </div>
                <HelpButton />
              </div>
            </RankProvider>
          </WalletProvider>
        </ProfileProvider >
      )
      }
    </>
  );
};

export default withTranslation()(withRouter(App));
